var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[_c('form-generator',{key:"variable render",attrs:{"schema":_vm.getSchemaFromStack(_vm.taskVariables),"readonly":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }